<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1 3C1 2.44772 1.44772 2 2 2H14C14.5523 2 15 2.44772 15 3C15 3.55228 14.5523 4 14 4H2C1.44772 4 1 3.55228 1 3Z"
    fill="currentColor"
  />

  <path
    d="M1 8C1 7.44772 1.44772 7 2 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H2C1.44772 9 1 8.55228 1 8Z"
    fill="currentColor"
  />

  <path
    d="M1 13C1 12.4477 1.44772 12 2 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H2C1.44772 14 1 13.5523 1 13Z"
    fill="currentColor"
  />
</svg>
